import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { useTranslation } from "@/hooks/useTranslation";

export interface EventTypeSelectorProps {
  includesWedding: boolean;
  includesBaptism: boolean;
  babyCount: 1 | 2 | null;
  onIncludesWeddingChange: (checked: boolean) => void;
  onIncludesBaptismChange: (checked: boolean) => void;
  onBabyCountChange: (count: 1 | 2) => void;
}

export function EventTypeSelector({
  includesWedding,
  includesBaptism,
  babyCount,
  onIncludesWeddingChange,
  onIncludesBaptismChange,
  onBabyCountChange,
}: EventTypeSelectorProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <Label className="text-base font-medium">
        {t("events.form.eventTypeQuestion")}
      </Label>
      <p className="text-sm text-muted-foreground">
        {t("events.form.eventTypeDescription")}
      </p>
      <div className="flex flex-wrap gap-6">
        <label className="flex items-center gap-2 cursor-pointer">
          <Checkbox
            checked={includesWedding}
            onCheckedChange={(checked) => onIncludesWeddingChange(!!checked)}
            aria-label={t("events.form.includesWedding")}
          />
          <span>{t("events.form.includesWedding")}</span>
        </label>
        <label className="flex items-center gap-2 cursor-pointer">
          <Checkbox
            checked={includesBaptism}
            onCheckedChange={(checked) => onIncludesBaptismChange(!!checked)}
            aria-label={t("events.form.includesBaptism")}
          />
          <span>{t("events.form.includesBaptism")}</span>
        </label>
      </div>
      {includesBaptism && (
        <div className="pl-6 border-l-2 border-muted space-y-2">
          <Label className="text-sm">
            {t("events.form.babyCount")}
          </Label>
          <RadioGroup
            value={babyCount === null ? "1" : String(babyCount)}
            onValueChange={(value) => onBabyCountChange(value === "2" ? 2 : 1)}
            className="flex gap-4"
          >
            <label className="flex items-center gap-2 cursor-pointer">
              <RadioGroupItem value="1" id="baby-count-1" />
              <span>{t("events.form.oneBaby")}</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <RadioGroupItem value="2" id="baby-count-2" />
              <span>{t("events.form.twoBabies")}</span>
            </label>
          </RadioGroup>
        </div>
      )}
    </div>
  );
}
